<div>
<nx-pageTitle-box
  [label]="mobileDevice?.name"
  [bcRootLvlLabel]="'coreModule.mobileDeviceViewComponent.title.rootLevelLabel'"
  [bcRootLvlPath]="'/settings'"
  [bcRootLvl1Label]="'coreModule.mobileDeviceViewComponent.title.rootLevel2Label'"
  [bcRootLvl1Path]="'/settings/mobileDevices'"
  [icon]="'icon-mobile-device'">
        <ng-template nxTemplate="tag">
          <p-tag
            [value]="updateLabel(mobileDevice?.updateState) | translate"
            [severity]="calculateSeverity(mobileDevice?.updateState)">
          </p-tag>
      </ng-template>
</nx-pageTitle-box>


<div class="flex flex-row gap-4 mt-2">
  <div
    class="basis-1/2">
    <nx-headline-box  
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.headline'">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.name.label'">
      {{mobileDevice?.name}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.id.label'">
      {{mobileDevice?.id}}
      <ng-template nxTemplate="end">
        <nx-default-button
          [style]="'light'"
          class="ml-2"
          [tooltip]="'coreModule.mobileDeviceViewComponent.generalDetails.idCopyToClipboardButtonTooltip'"
          (click)="copyIdToClipboard(mobileDevice?.id)"
          [icon]="'icon-copy'">
        </nx-default-button>
      </ng-template>
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.platform.label'">
      {{mobileDevice?.platform}}
    </nx-default-box> 
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.model.label'">
      {{mobileDevice?.model}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.osVersion.label'">
      {{mobileDevice?.osVersion}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.lastSeen.label'">
      {{mobileDevice?.lastSeenDateTime | date:'dd.MM.yyyy HH:mm'}}
    </nx-default-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.createdDateTime.label'">
      {{mobileDevice?.createdDateTime | date:'dd.MM.yyyy HH:mm'}}
    </nx-default-box>
    <!-- <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.generalDetails.permissions.headline'">
      {{ getPermissions(mobileDevice?.permissions) }}
    </nx-default-box> -->
  </div>
  <div
    class="basis-1/2">
    <nx-headline-box  
      [label]="'coreModule.mobileDeviceViewComponent.userDetails.headline'">
    </nx-headline-box>
    <nx-default-box
      class="bg-white border-b border-gray"
      [label]="'coreModule.mobileDeviceViewComponent.userDetails.name.label'">
      <a [routerLink]="['/settings/users/user/', mobileDevice?.user?.id ]" class="jump">
        {{mobileDevice?.user?.firstName}} {{mobileDevice?.user?.lastName}}
        <i [className]="'icon icon-jump-to'"></i>
      </a>
    </nx-default-box>

    <ng-container
      *ngIf="isAdmin()">
      <nx-headline-box  
        class="mt-2"
        [label]="'coreModule.mobileDeviceViewComponent.debugDetails.headline'">
        <ng-template
          nxTemplate="end">
          <nx-default-button
            *ngIf="mobileDevice?.debugDeviceUrl"
            [style]="'light'"
            class="ml-2"
            [tooltip]="'coreModule.mobileDeviceViewComponent.debugDetails.goToDebugToolButtonTooltip'"
            (click)="gotToUrl(mobileDevice?.debugDeviceUrl)"
            [icon]="'icon-link'">
          </nx-default-button>
        </ng-template>
      </nx-headline-box>
      <nx-default-box
        class="bg-white border-b border-gray"
        [label]="'coreModule.mobileDeviceViewComponent.debugDetails.androidSdk.label'">
        {{mobileDevice?.androidSdk}}
      </nx-default-box>
      <nx-default-box
        class="bg-white border-b border-gray"
        [label]="'coreModule.mobileDeviceViewComponent.debugDetails.language.label'">
        {{mobileDevice?.language}}
      </nx-default-box>
      <nx-default-box
        class="bg-white border-b border-gray"
        [label]="'coreModule.mobileDeviceViewComponent.debugDetails.locale.label'">
        {{mobileDevice?.locale}}
      </nx-default-box>
    </ng-container>
  </div>
</div>